import { get, post, put } from '.';

export function GetCampaignCustomerActives(options = {}) {
	return get<any>("/app/api/campaign_customer_actives", options);
}

export function GetCampaignCustomerActivesForAttemptManagement(options = {}) {
	return get<any>("/app/api/campaign_customer_actives/attempt_management", options);
}

export function GetCampaignCustomerOtherAvailableCampaigns(id, options = {}) {
	return get<any>("/app/api/campaign_customer_actives/" + (id || 0).toString() + "/other_available_campaigns", options);
}

export function GetUnrespondedToCommunications(options = {}) {
	return get<any>("/app/api/campaign_customer_actives/unresponded_to_communications", options);
}


export function ProcessCampaignCustomerActive(options = {}) {
	return post<any>("/app/api/process_campaign_customer_active", options);
}

export function SwitchCampaignForCampaignCustomerActive(id, options = {}) {
	return put<any>("/app/api/campaign_customer_actives/" + (id || 0).toString() + "/switch_campaign", options);
}

export function UpdateCampaignCustomerActive(options = {}) {
	return put<any>("/app/api/campaign_customer_active", options);
}

export function UpdateCampaignCustomerActiveCustomerVehicle(id, options = {}) {
	return put<any>("/app/api/campaign_customer_active_customer_vehicle/" + (id || 0).toString(), options);
}

export function SwitchCustomerForCampaignCustomerActive(id, options = {}) {
	return put<any>("/app/api/campaign_customer_actives/" + (id || 0).toString() + "/switch_customer", options);
}

export function SwitchOrganizationForCampaignCustomerActive(id, options = {}) {
	return put<any>("/app/api/campaign_customer_actives/" + (id || 0).toString() + "/switch_organization", options);
}

export function UnassignAllCampaignCustomerActives(options = {}) {
	return post<any>("/app/api/campaign_customer_actives/unassign_all", options);
}

export function UnassignCampaignCustomerActivesFromCampaigns(options = {}) {
	return post<any>("/app/api/campaign_customer_actives/unassign_from_campaigns", options);
}
